import React, { Fragment, useEffect, useState } from 'react'
import BodyTab from '../MainOrder/BodyTab'
import { Button, Tabs } from 'antd'
import SleeveTab from '../MainOrder/SleeveTab'
import CapTab from '../MainOrder/CapTab'
import menuubody from '../../assets/images/body.png';
import menuuSleeve from "../../assets/images/sleeve.png";
import menuuCap from "../../assets/images/cap.png";

const ShirtTabs = ({handleCapColor, handleCapMarkingColor, handleCapId, capColors, capMarkingColor, handlesleevesColor, handleSleevesMarkingColor, handleSleeveId,  sleeveColors, sleevesMarkingColor, handleBodyColor, handleBodyMarkingColor, handleBodyId, bodyColors, bodyMarkingColors}) => {
    const [tabPosition, setTabPosition] = useState('left');

    useEffect(() => {
        const handleResize = () => {
            setTabPosition(window.innerWidth < 576 ? 'top' : 'left');
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
      <Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12 noooPad">
              <Tabs tabPosition={tabPosition} className="shhhirtTab">
                <Tabs.TabPane
                  key="1"
                  tab={
                    <Button>
                      <img src={menuubody} alt="" />
                      Body
                    </Button>
                  }
                >
                  <BodyTab
                    handleBodyColor={handleBodyColor}
                    handleBodyMarkingColor={handleBodyMarkingColor}
                    handleBodyId={handleBodyId}
                    bodyColors={bodyColors}
                    bodyMarkingColors={bodyMarkingColors}
                  />
                </Tabs.TabPane>
                <Tabs.TabPane
                  key="2"
                  tab={
                    <Button>
                      <img src={menuuSleeve} alt="" />
                      Sleeves
                    </Button>
                  }
                >
                  <SleeveTab
                    handlesleevesColor={handlesleevesColor}
                    handleSleevesMarkingColor={handleSleevesMarkingColor}
                    handleSleeveId={handleSleeveId}
                    sleeveColors={sleeveColors}
                    sleevesMarkingColor={sleevesMarkingColor}
                  />
                </Tabs.TabPane>
                <Tabs.TabPane
                  key="3"
                  tab={
                    <Button>
                      <img src={menuuCap} alt="" />
                      Cap
                    </Button>
                  }
                >
                  <CapTab
                    handleCapColor={handleCapColor}
                    handleCapMarkingColor={handleCapMarkingColor}
                    handleCapId={handleCapId}
                    capColors={capColors}
                    capMarkingColor={capMarkingColor}
                  />
                </Tabs.TabPane>
              </Tabs>
            </div>
          </div>
        </div>
      </Fragment>
    );
}

export default ShirtTabs